import { createReducer, on } from '@ngrx/store';
import * as MeetingActions from './meeting.actions';
import type { MeetingState } from './meeting.models';

export const initialMeetingState: MeetingState = {
  currentSession: null,
  incomingCall: null,
  meetingStatusByChannelId: {},
  loading: false,
  error: null,
  message: null,
  success: false,
};

export const meetingReducer = createReducer(
  initialMeetingState,
  on(MeetingActions.MeetingStartChannelRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(MeetingActions.MeetingAnswerChannelRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(MeetingActions.MeetingJoinChannelRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(MeetingActions.MeetingDeclineChannelRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(MeetingActions.MeetingStartChannelSuccess, (state, { session, message }) => ({
    ...state,
    currentSession: session,
    incomingCall: state.incomingCall?.channel_id === session.channel_id ? null : state.incomingCall,
    loading: false,
    error: null,
    message,
    success: true,
  })),
  on(MeetingActions.MeetingAnswerChannelSuccess, (state, { session, message }) => ({
    ...state,
    currentSession: session,
    incomingCall: state.incomingCall?.channel_id === session.channel_id ? null : state.incomingCall,
    loading: false,
    error: null,
    message,
    success: true,
  })),
  on(MeetingActions.MeetingJoinChannelSuccess, (state, { session, message }) => ({
    ...state,
    currentSession: session,
    incomingCall: state.incomingCall?.channel_id === session.channel_id ? null : state.incomingCall,
    loading: false,
    error: null,
    message,
    success: true,
  })),
  on(MeetingActions.MeetingGetChannelStatusSuccess, (state, { status }) => ({
    ...state,
    meetingStatusByChannelId: {
      ...state.meetingStatusByChannelId,
      [status.channel_id]: status,
    },
  })),
  on(MeetingActions.MeetingStartChannelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    message: null,
    success: false,
  })),
  on(MeetingActions.MeetingAnswerChannelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    message: null,
    success: false,
  })),
  on(MeetingActions.MeetingJoinChannelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    message: null,
    success: false,
  })),
  on(MeetingActions.MeetingGetChannelStatusFailure, (state) => ({
    ...state,
  })),
  on(MeetingActions.MeetingDeclineChannelSuccess, (state, { channelId, message }) => ({
    ...state,
    currentSession: state.currentSession?.channel_id === channelId ? null : state.currentSession,
    incomingCall: state.incomingCall?.channel_id === channelId ? null : state.incomingCall,
    loading: false,
    error: null,
    message,
    success: true,
  })),
  on(MeetingActions.MeetingDeclineChannelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    message: null,
    success: false,
  })),
  on(MeetingActions.MeetingEndChannelSuccess, (state, { channelId, message }) => ({
    ...state,
    currentSession: state.currentSession?.channel_id === channelId ? null : state.currentSession,
    loading: false,
    error: null,
    message,
    success: true,
  })),
  on(MeetingActions.MeetingEndChannelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    message: null,
    success: false,
  })),
  on(MeetingActions.MeetingReceiveIncomingCall, (state, { incomingCall }) => ({
    ...state,
    incomingCall,
  })),
  on(MeetingActions.MeetingDismissIncomingCall, (state) => ({
    ...state,
    incomingCall: null,
  })),
  on(MeetingActions.MeetingReceiveEndSignal, (state, { channelId }) => ({
    ...state,
    currentSession: state.currentSession?.channel_id === channelId ? null : state.currentSession,
    incomingCall: state.incomingCall?.channel_id === channelId ? null : state.incomingCall,
  }))
);
